var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1232 0.7072L15.8539 6.25703C16.0422 6.6342 16.392 6.89015 16.809 6.94403L22.916 7.83309C23.9518 7.98126 24.3688 9.26095 23.6155 9.98835L19.1899 14.2989C18.894 14.5952 18.7594 15.0128 18.8267 15.4169L19.8759 21.5191C20.0508 22.5563 18.9747 23.3376 18.0465 22.8526L12.5851 19.97C12.222 19.7814 11.778 19.7814 11.4149 19.97L5.9535 22.8526C5.02533 23.3376 3.9492 22.5563 4.12407 21.5191L5.1733 15.4169C5.24056 15.0128 5.10605 14.5818 4.81011 14.2989L0.384523 9.98835C-0.368768 9.26095 0.048228 7.98126 1.084 7.83309L7.19104 6.94403C7.60804 6.89015 7.95778 6.62073 8.14611 6.25703L10.8768 0.7072C11.3342 -0.235733 12.6793 -0.235733 13.1367 0.7072H13.1232Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/gray-star.64a7cf5977d22db2b4cb23f6cbc6d378.svg";
export { ForwardRef as ReactComponent };